/**
 * Utilitaire — extrait le message d'erreur d'un FieldErrors RHF en suivant
 * un chemin pointe (ex: `series.position` ou `tags.0.label`).
 *
 * RHF stocke les erreurs en arborescence : `errors.foo.bar = { message, type }`.
 * Pour un champ imbrique on doit walker le path manuellement, sinon
 * `errors[name]?.message` retourne `undefined` sur les chemins composes.
 */
export function getNestedError(errors: Record<string, unknown>, name: string): string | undefined {
  const keys = name.split('.')
  let current: unknown = errors
  for (const key of keys) {
    if (typeof current !== 'object' || current === null) return undefined
    current = (current as Record<string, unknown>)[key]
  }
  if (typeof current !== 'object' || current === null) return undefined
  if (!('message' in current)) return undefined
  const msg = (current as { message?: unknown }).message
  return typeof msg === 'string' ? msg : undefined
}
